export enum UserStatuses {
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
  IN_ACCEPTANCE = 'InAcceptance'
}
